(() => {
  const tool = document.getElementById('epj-compare-tool');
  if (!tool) return;

  const selected = new Map();
  const bar = tool.querySelector('.epj-compare-tool__bar');
  const count = tool.querySelector('.epj-compare-tool__count');
  const limit = tool.querySelector('.epj-compare-tool__limit');
  const overlay = tool.querySelector('.epj-compare-tool__overlay');
  const dialog = tool.querySelector('.epj-compare-tool__dialog');
  const table = tool.querySelector('.epj-compare-tool__table');
  const close = tool.querySelector('.epj-compare-tool__close');
  let previousFocus;
  let previousOverflow;
  let chatRoot;
  let chatButton;
  const chatResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(positionBar) : null;
  const chatMutationObserver = new MutationObserver(positionBar);

  function positionBar() {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    if (root && root !== chatRoot) {
      chatMutationObserver.disconnect();
      chatMutationObserver.observe(root, { attributes: true, childList: true, subtree: true });
      chatRoot = root;
    }
    const button = root?.querySelector('button.activator');
    if (button !== chatButton) {
      if (chatButton) chatResizeObserver?.unobserve(chatButton);
      if (button) chatResizeObserver?.observe(button);
      chatButton = button;
    }
    const rect = button?.getBoundingClientRect();
    const bottom = rect?.width && rect?.height && rect.top >= 0 && rect.top < innerHeight
      ? Math.max(90, innerHeight - rect.top + 16)
      : 90;
    bar.style.setProperty('--epj-compare-bottom', `${Math.ceil(bottom)}px`);
  }

  const clean = value => {
    const text = (value || '').trim();
    return /^(?:n\/a|null|undefined)$/i.test(text) ? '' : text;
  };
  const read = input => ({
    id: input.dataset.id,
    name: clean(input.dataset.name),
    url: input.dataset.url,
    image: input.dataset.image || '',
    price: clean(input.dataset.price),
    capacity: clean(input.dataset.capacity),
    battery: clean(input.dataset.battery),
    runtime: clean(input.dataset.runtime),
    warranty: clean(input.dataset.warranty),
    bestFit: clean(input.dataset.bestFit)
  });
  const cell = (tag, value) => {
    const element = document.createElement(tag);
    element.textContent = value;
    return element;
  };

  function sync() {
    document.querySelectorAll('.epj-compare-pick__input').forEach(input => {
      input.checked = selected.has(input.dataset.id);
      input.disabled = selected.size >= 4 && !input.checked;
    });
    count.textContent = selected.size;
    bar.hidden = selected.size < 2;
    limit.hidden = selected.size < 4;
    if (!bar.hidden) positionBar();
  }

  document.addEventListener('change', event => {
    const input = event.target.closest('.epj-compare-pick__input');
    if (!input) return;
    if (input.checked && selected.size < 4) selected.set(input.dataset.id, read(input));
    else if (!input.checked) selected.delete(input.dataset.id);
    sync();
  });

  function renderTable() {
    const products = Array.from(selected.values());
    const head = table.tHead || table.createTHead();
    const body = table.tBodies[0] || table.createTBody();
    head.replaceChildren();
    body.replaceChildren();

    const headerRow = head.insertRow();
    headerRow.append(cell('th', tool.dataset.labelSpec));
    products.forEach(product => {
      const th = document.createElement('th');
      const link = document.createElement('a');
      link.className = 'epj-compare-tool__product-link';
      link.href = product.url;
      if (product.image) {
        const image = document.createElement('img');
        image.className = 'epj-compare-tool__product-image';
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 96;
        image.height = 96;
        link.append(image);
      }
      link.append(cell('span', product.name));
      th.append(link);
      headerRow.append(th);
    });

    [
      ['price', tool.dataset.labelPrice],
      ['capacity', tool.dataset.labelCapacity],
      ['battery', tool.dataset.labelBattery],
      ['runtime', tool.dataset.labelRuntime],
      ['warranty', tool.dataset.labelWarranty],
      ['bestFit', tool.dataset.labelBestFit]
    ].forEach(([key, label]) => {
      if (!products.some(product => product[key])) return;
      const row = body.insertRow();
      row.append(cell('th', label));
      products.forEach(product => row.append(cell('td', product[key] || '—')));
    });
  }

  function closeDialog() {
    if (overlay.hidden) return;
    overlay.hidden = true;
    document.body.style.overflow = previousOverflow;
    previousFocus?.focus();
  }
  tool.querySelector('.epj-compare-tool__action').addEventListener('click', () => {
    if (selected.size < 2) return;
    document.querySelectorAll('.epj-compare-pick__input:checked').forEach(input => selected.set(input.dataset.id, read(input)));
    renderTable();
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    dialog.focus();
  });
  close.addEventListener('click', closeDialog);
  overlay.addEventListener('click', event => {
    if (event.target === overlay) closeDialog();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeDialog();
  });

  const results = document.querySelector('.product-listing-wrapper .result-container');
  if (results) new MutationObserver(sync).observe(results, { childList: true, subtree: true });
  window.addEventListener('resize', positionBar);
  window.addEventListener('load', positionBar, { once: true });
  setTimeout(positionBar, 2000);
  sync();
})();
